<div class="flex flex-col gap-4">
  <h5 class="text-xl">{{ myTranslation("officeAddin.salesData") }}</h5>
  <p-floatLabel variant="in">
    <p-calendar
      [(ngModel)]="myDate"
      selectionMode="range"
      dateFormat="dd.mm.yy"
      (click)="resetDateSelector()"
    ></p-calendar>
    <label [class]="dateSelectorState">{{ myTranslation("officeAddin.timeFrame") }}</label>
  </p-floatLabel>

  <label>
    <p-checkBox [(ngModel)]="includeAllOrganizations" [binary]="true" (onChange)="resetOrganizationSelector()">
    </p-checkBox>
    <span>{{ myTranslation("officeAddin.includeAllOrganizations") }}</span>
  </label>
  <p-floatLabel variant="in">
    <p-multiSelect
      [options]="groupedOrganizations"
      [group]="true"
      [(ngModel)]="selectedOrganizations"
      [style]="{ width: '100%' }"
      [panelStyle]="{ width: '100%' }"
      (click)="resetOrganizationSelector()"
      [disabled]="includeAllOrganizations"
    >
      ></p-multiSelect
    >
    <label [class]="organizationSelectorState">{{ myTranslation("officeAddin.organizations") }}</label>
  </p-floatLabel>
  <p-floatLabel variant="in">
    <p-multiSelect
      [options]="tableTypes"
      [(ngModel)]="selectedTableType"
      [style]="{ width: '100%' }"
      [panelStyle]="{ width: '100%' }"
      (click)="resetTableSelector()"
    >
    </p-multiSelect>
    <label [class]="tableSelectorState">{{ myTranslation("officeAddin.analysis") }}</label>
  </p-floatLabel>
  <new-ui-button label="Sales Daten importieren" (click)="getData()"></new-ui-button>
</div>
